import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  activeSubscriptionIdState,
  modelFunctions_rolesState,
} from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { unlinkModelFunctionFromRole } from "../../../api/unlink-model-function-from-role";

type Props = {
  modelFunctionId: Id;
  roleId: Id;
  onSuccess: () => void;
};

export const UnlinkModelFunctionFromRole: FC<Props> = (props) => {
  const { modelFunctionId, roleId, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setModelFunctions_roles = useSetRecoilState(modelFunctions_rolesState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        unlinkModelFunctionFromRole({
          modelFunctionId,
          roleId,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setModelFunctions_roles(event.data.modelFunctions_roles);
        onSuccess();
        toast({
          title: "koppeling tussen modelfunctie en rol verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van koppeling niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
